import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledCopy = styled.p`
  font-size: ${theme.token.var('fontSizes.md')};
  text-align: left;
  margin-top: 12px;
  font-weight: 300;

  @media (min-width: ${theme.token('breakpoints.md')}) {
    margin-top: 0;
  }
`

export const StyledCopyCentered = styled.p`
  font-size: ${theme.token.var('fontSizes.md')};
  text-align: center;
  margin-top: 12px;
  font-weight: 300;

  @media (min-width: ${theme.token('breakpoints.md')}) {
    margin-top: 0;
  }
`
